import { api } from "@/lib/api";

// Voice clips for comment text, cached per voice + wording so previews are reused at Start.
const cache = {};

export async function getVoiceClip(text, voice) {
  const key = `${voice}|${text.trim()}`;
  if (!cache[key]) {
    const r = await api.post("/ai/speak", { text: text.trim(), voice }, { responseType: "blob", timeout: 60000 });
    cache[key] = URL.createObjectURL(r.data);
  }
  return cache[key];
}
